import React, {useState} from 'react';
import './TextBoxWithIcon.css'; // Make sure to create this CSS file to style the input

const TextBoxWithIcon = ({maxLength=1000, required=false, Img, imgColor, placeholder, label, inputType, value, onChange, wrapperStyle={}, inputStyle={}, className="", wrapperClassName="" }) => {
    const [isFocused, setIsFocused] = useState(false);
    const shouldFloat = isFocused || value.length > 0;
    return (
        <div className={"input-container "+wrapperClassName} style={wrapperStyle}>
            {!value && !isFocused && React.createElement(Img, { className: "icon", style: { color: imgColor } })}
            {label && (
                <label className={`floating-label ${shouldFloat ? 'active' : ''}`}>
                    {label}
                </label>
            )}
            <input
                type={inputType}
                placeholder={placeholder}
                className={"input-field "+className}
                value={value}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                style={inputStyle}
                maxLength={maxLength}
            />
        </div>
    );
};
export default TextBoxWithIcon;